import * as constant from '../Constants/loginConstant';

export const userLogingIn = (userCredential)=>({
    type: constant.USER_LOGIN,
    payload: userCredential
})

export const userLogOut =()=>({
    type: constant.USER_LOGIN_CLEANUP
})